// extracted by mini-css-extract-plugin
export default {"close":"Close_close__kOz9B","hamburger":"Close_hamburger__9yNP4","pulsate":"Close_pulsate__TAYvH"};